import UserRepository from "./repositories/UserRepository";
import CalendarRepository from "./repositories/CalendarRepository";
import CategoryRepository from "./repositories/CategoryRepository";
import GroupRepository from "./repositories/GroupRepository";
import ProposalRepository from "./repositories/ProposalRepository";
import CommentRepository from "./repositories/CommentRepository";
import TagRepository from "./repositories/TagRepository";
import TodoRepository from "./repositories/TodoRepository";
import DocumentRepository from "./repositories/DocumentRepository";
import TemplateRepository from './repositories/TemplateRepository';
import DocumentTemplateRepository from "./repositories/DocumentTemplateRepository";
import LandingPageRepository from "./repositories/LandingPageRepository";
import SettingRepository from "./repositories/SettingRepository";
import ApplicationRepository from "./repositories/ApplicationRepository";
import AppCategoryRepository from "./repositories/AppCategoryRepository";
import LandingRepository from "./repositories/LandingRepository";
import MemoRepository from "./repositories/MemoRepository";
import TypeRepository from "./repositories/TypeRepository";
import WorkRepository from "./repositories/WorkRepository";
import RequestEbookRepository from "./repositories/RequestEbookRepository";
import PlanRepository from "./repositories/PlanRepository";
import ChannelRepository from './repositories/ChannelRepository';
import PaperRepository from "./repositories/PaperRepository";

export default ($axios) => ({
  users: UserRepository($axios),
  calendar: CalendarRepository($axios),
  categories: CategoryRepository($axios),
  groups: GroupRepository($axios),
  proposals: ProposalRepository($axios),
  comments: CommentRepository($axios),
  tags: TagRepository($axios),
  todos: TodoRepository($axios),
  documents: DocumentRepository($axios),
  templates: TemplateRepository($axios),
  documentTemplates: DocumentTemplateRepository($axios),
  landingPage: LandingPageRepository($axios),
  settings: SettingRepository($axios),
  applications: ApplicationRepository($axios),
  appCategories: AppCategoryRepository($axios),
  landing: LandingRepository($axios),
  memo: MemoRepository($axios),
  type: TypeRepository($axios),
  work: WorkRepository($axios),
  requestEbook: RequestEbookRepository($axios),
  plan: PlanRepository($axios),
  channels: ChannelRepository($axios),
  papers: PaperRepository($axios),
});
